module.exports = __webpack_public_path__ + "static/UploadLimit-2bf0d3d023ec52fa9ff538ceea15cb4b.png";